/****************************************************************************************************
 * * TYPES DEMO COMPONENT
 * --------------------------------------------------------------------------------------------------
 * Types demo component is a component that displays a YouTube video with a title.
 * This is a demo of how to create a component with a custom type that can be added
 * to portable text.
 * *************************************************************************************************/

import React from 'react';
import { Box } from '@mui/material';
import { Typography } from 'ui';

/********************************************************************************
 * * TYPES DEMO PROPS
 * ------------------------------------------------------------------------------
 * Export types from the component. This is something that is not required by
 * other compoennts, but may be userful at some point in other components so it's
 * being defined and exported.
 * ******************************************************************************/
export type TypesDemoProps = {
  value: {
    title: string;
    videoId: string;
  };
};

const TypesDemo = ({ value }: TypesDemoProps) => {
  // Bail if no value
  if (!value) return null;

  // Destructure the value attributes
  const { title = 'DEMO', videoId = 'tZcg6dyiW7E' } = value;

  return (
    <Box
      width="100%"      
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      sx={{ background: 'rgba(0,0,0,0.2)' }}      
    >
      <Box mb={2}>
        <Typography variant="h2">{title}</Typography>
      </Box>
      <Box
        sx={{
          width: '100%', // Width of the video container
          height: 0, // Collapse the container's height
          paddingBottom: '56.25%', // Maintain aspect ratio (16:9)
          position: 'relative', // For absolute positioning of the iframe
        }}
      >
        <Box
          component="iframe"
          // src={`https://www.youtube.com/embed/tZcg6dyiW7E?si=6kpziKoDSSjPAQO6`}
          src={`https://www.youtube.com/embed/${videoId}?si=6kpziKoDSSjPAQO6`}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          sx={{
            position: 'absolute', // Position absolute to fit the parent container
            top: 0,
            left: 0,
            width: '100%', // Take full width of the container
            height: '100%', // Take full height of the container
          }}
        />
      </Box>
    </Box>
  );
};

export default TypesDemo;
